export type IsoDate = string;

export function todayIso(): IsoDate {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function addDays(isoDate: IsoDate, days: number): IsoDate {
  const [year, month, day] = isoDate.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseIso(isoDate: IsoDate): Date {
  const [year, month, day] = isoDate.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function formatLong(isoDate: IsoDate): string {
  return parseIso(isoDate).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function monthLabel(year: number, month: number): string {
  return new Date(year, month, 1).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
}

export function inRange(isoDate: IsoDate, startDate: IsoDate, endDate: IsoDate): boolean {
  return isoDate >= startDate && isoDate < endDate;
}

export function rangesOverlap(aStart: string, aEnd: string, bStart: string, bEnd: string): boolean {
  return aStart < bEnd && bStart < aEnd;
}

export function isBusy(
  isoDate: IsoDate,
  ranges: { startDate: string; endDate: string }[],
): boolean {
  return ranges.some((range) => inRange(isoDate, range.startDate, range.endDate));
}

export function rangeHitsBusy(
  startDate: IsoDate,
  endDate: IsoDate,
  ranges: { startDate: string; endDate: string }[],
): boolean {
  return ranges.some((range) => rangesOverlap(startDate, endDate, range.startDate, range.endDate));
}

export function nightsBetween(startDate: IsoDate, endDate: IsoDate): number {
  return Math.round((parseIso(endDate).getTime() - parseIso(startDate).getTime()) / 86_400_000);
}
